import { CircleChevronRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";

export function CardStat({ title, value, icon, color, onClick, url = null, ...props }) {
   return (
      <div style={{ '--cardStatColor': color, ...props.style }} className={cn("flex flex-row gap-4 items-start w-full border! border-(--borderColor)! rounded-(--borderRadius)! **:text-(--textColor) px-5! py-6! box-border! bg-(--containerBackgroundColor)! shadow-(--box-shadow)", props.className)}>
         <span className="flex items-center justify-center size-12! bg-(--cardStatColor) **:text-white! rounded-full shadow-(--box-shadow)">
            {React.createElement(icon, { size: 28 })}
         </span>
         <span className="flex flex-col gap-2">
            <span className="muted-sm text-[11px]! p-0! m-0!">
               {title}
            </span>
            <span className="text-xl! font-bold!">
               {value}
            </span>
            {url && (
               <Link to={url} className="inline-flex flex-row items-center group gap-2 text-sm! hover:text-(--primaryColor)! font-bold! mt-1! leading-[0.1]! duration-200">
                  <CircleChevronRight size={18} className="relative group-hover:translate-x-0.5 group-hover:**:text-(--primaryColor)! duration-200" />
                  Ver todos
               </Link>
            )}
            {onClick && (
               <button type="button" onClick={onClick} className="inline-flex flex-row items-center group gap-2 text-sm! hover:text-(--primaryColor)! font-bold! mt-1! leading-[0.1]! duration-200">
                  <CircleChevronRight size={18} className="relative group-hover:translate-x-0.5 group-hover:**:text-(--primaryColor)! duration-200" />
                  Ver todos
               </button>
            )}
         </span>
      </div>
   );
}